export default __webpack_public_path__ + "static/media/Ma part d'ombre.66f132bf.jpg";